import React from 'react';
import { Container, Header, Cms, Button } from 'components';
import { Margin } from 'styled-components-spacing';
import { openCookieSettings } from 'helpers/cookieConsent';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.app.cookiePolicy',
    url: '',
  },
];

const CookiePolicy = () => {
  return (
    <>
      <Header breadcrumbs={breadcrumbs} title="Cookie Policy" />
      <Margin vertical={{ xs: 32, md: 48 }}>
        <Container>
          <Cms>
            <p>
              A Cookie is a small piece of data (text file) that a website asks your browser to
              store on your device.
              <br /> A Cookie doesn’t harm your device and it cannot be used to distribute malware.
            </p>
            <p>
              With Cookies IPMA can improve the user experience, but also use them to measure
              traffic in its online services, to modify content based on browsing actions and
              previous visits, or for advertising purposes.
            </p>
            <h4>Which cookies we use</h4>
            <p>
              <strong>Strictly necessary cookies</strong> are required to run MyIPMA – they keep you
              signed in, protect forms against abuse and remember the cookie choice you make below.
              They are always active and cannot be switched off, because the service cannot work
              without them.
            </p>
            <p>
              <strong>Analytics and marketing cookies</strong> (Google Analytics and Google Tag
              Manager) help us measure traffic, tailor content based on your browsing and previous
              visits, and support advertising. These are set{' '}
              <strong>only if you accept them</strong>. If you reject them, they are never loaded
              and MyIPMA keeps working exactly the same – no feature depends on them.
            </p>
            <h4>Changing your mind</h4>
            <p>
              Your choice is stored for six months and you can change it at any time – accepting is
              not permanent and refusing is not final. If you withdraw your consent, the analytics
              and marketing cookies already stored are removed from your browser.
            </p>
            <p>
              Your browser is likely configured to automatically accept Cookies, but you can change
              the options, as well as delete the Cookies in your browser&#39;s settings.
            </p>
          </Cms>
          <Margin top={{ xs: 24 }}>
            <Button type="button" auto="md" onClick={openCookieSettings}>
              Change your cookie settings
            </Button>
          </Margin>
        </Container>
      </Margin>
    </>
  );
};

export default CookiePolicy;
